import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { convertCityPartsToString } from "../../../../helpers/cityHelper/convertCityPartsToString";
import { setPathToSelfShipment } from "../../../path/pathSlice";
import {
    openShipmentEventsPopup,
} from "../../shipmentEvents/shipmentEventsSlice";
import { Button } from "@mui/material";
import { convertApiTimeToString, convertApiTimeToStringWithoutTime } from "../../../../helpers/time/convertApiTime";
import {
    openSendToAkadPopup,
} from "../../shipmentsSlice";
import WhiteSpinner from "../../../../components/loaders/WhiteSpinner";
import { useTranslation } from "react-i18next";
import { COURIER_DELIVERY_TYPE, deliveryTypes, i18nLangs } from "../../../../data/static-data";
import { getCityFullName } from "../../../citySelect/getCityFullName";

const ShipmentsTableItem = ({ shipment }) => {
    const {t, i18n} = useTranslation()
    const dispatch = useDispatch();

    const [isSending, setIsSending] = useState(false);

    const gettingPackageType = 
        deliveryTypes
        .find(type => {
            return type.value === shipment["getting-package-type"]
        })
        ?.text[i18n.language]
        ?? ""

    let receiverCityName = getCityFullName(
        {
            city: shipment["receiver-city-tr"],
            district: shipment["receiver-district-tr"],
            area: shipment["receiver-area-tr"]
        },
        i18nLangs.TR
    );
    let receiverCountryName = shipment["receiver-country-tr"];

    useEffect(() => {
        setIsSending(shipment.isSending);
    }, [shipment.isSending]);

    const handleTrcClick = () => {
        dispatch(setPathToSelfShipment({ id: shipment.id }));
    };

    const handleEventsClick = () => {
        dispatch(openShipmentEventsPopup({shipmentTrc : shipment.trc}));
    };

    const handleSendToAkadButtonClick = (e) => {
        if (!shipment.id) {
            return;
        }
        dispatch(
            openSendToAkadPopup({
                shipmentID: shipment.id,
            })
        );
    };

    return (
        <tr>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <span
                        className="cursor-pointer text-emerald-600"
                        onClick={handleTrcClick}
                    >
                        {shipment.id}
                    </span>
                    <span className="break-all">{shipment["sender-name"]}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <span
                        className="break-all cursor-pointer text-emerald-600"
                        onClick={handleTrcClick}
                    >
                        {shipment.trc ? shipment.trc : t("shipments.shipments_list.table.no_tracking")}
                    </span>
                    <span>{gettingPackageType}</span>
                </div>
            </td>
            <td className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                    <span>{shipment["price-USD"]}$</span>
                    <span>{shipment["price-TRY"]}₺</span>
                </div>
            </td>
            <td className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                    <span className="break-all">{receiverCountryName + ", " + receiverCityName}</span>
                    <span className="break-all">{shipment["receiver-name"]}</span>
                </div>
            </td>
            <td className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                    <span>{convertApiTimeToString(shipment["created-time"], i18n.language)}</span>
                    <span>{convertApiTimeToString(shipment["updated-time"], i18n.language)}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <>
                        {shipment.blocked && (
                            <>
                                <span className="text-gray-600 uppercase">
                                    {t("shipments.shipments_list.table.sended")}
                                </span>
                                <span className="text-gray-600 text-3xs">
                                    {convertApiTimeToStringWithoutTime(shipment["blocked-at"], i18n.language)}
                                </span>
                            </>
                        )}

                        {!shipment.blocked && (
                            <>
                                {isSending ? (
                                    <div>
                                        <WhiteSpinner width={15} height={15} />
                                    </div>
                                ) : (
                                    <Button
                                        variant="contained"
                                        sx={{
                                            color: "white",
                                            bgcolor: "#059669",
                                            padding: "5px 5px",
                                            fontSize: ".53rem",
                                            fontWeight: "bold",
                                            margin: "auto",
                                            width: "80%",
                                            ":hover": {
                                                bgcolor: "#047857",
                                            },
                                            ":focus": {
                                                bgcolor: "#047857",
                                            },
                                            "@media (max-width: 475px)": {
                                                fontSize: ".45rem",
                                            },
                                        }}
                                        className="uppercase"
                                        onClick={handleSendToAkadButtonClick}
                                    >
                                        {
                                            shipment && shipment["getting-package-type"] === COURIER_DELIVERY_TYPE ?
                                            t("shipments.shipments_list.table.call_courier_button"):
                                            t("shipments.shipments_list.table.send_button")
                                        }
                                    </Button>
                                )}
                            </>
                        )}
                    </>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    {shipment["is-delivered"] && (
                        <>
                            <span className="text-emerald-600 uppercase font-bold text-3xs">
                                {t("shipments.shipments_list.table.delivered")}
                            </span>
                        
                            <span className="text-gray-600">
                                {convertApiTimeToStringWithoutTime(shipment["delivery-time"], i18n.language)}
                            </span>
                        </>

                    )}

                    {!shipment["is-delivered"] && (
                        <Button
                            variant="contained"
                            sx={{
                                color: "white",
                                bgcolor: "#059669",
                                padding: "5px 2px",
                                fontSize: ".53rem",
                                fontWeight: "bold",
                                ":hover": {
                                    bgcolor: "#047857",
                                },
                                ":focus": {
                                    bgcolor: "#047857",
                                },
                                "@media (max-width: 475px)": {
                                    fontSize: ".45rem",
                                },
                            }}
                            className="uppercase"
                            onClick={handleEventsClick}
                        >
                            {t("shipments.shipments_list.table.events_button")}
                        </Button>
                    )}
                </div>
            </td>
        </tr>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps.shipment) === JSON.stringify(nextProps.shipment);
}

export default React.memo(ShipmentsTableItem, propsAreEqual);
